The verification status code.
